export * from "./ManagementSecondSpecCard";
export * from "./ManagementSecondSpecs";
